import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["readerSelect", "csvPanel", "wooPanel", "planIdRows"]

  connect() {
    this.togglePanels()
  }

  togglePanels() {
    const v = this.readerSelectTarget.value
    this.csvPanelTarget.classList.toggle("d-none", v !== "csv")
    this.wooPanelTarget.classList.toggle("d-none", v !== "woo_commerce_memberships")
  }

  addPlanId() {
    if (!this.hasPlanIdRowsTarget) return
    this.planIdRowsTarget.appendChild(this.buildPlanIdRow())
  }

  removePlanId(event) {
    const row = event.currentTarget.closest("[data-plan-id-row]")
    if (!row || !this.hasPlanIdRowsTarget) return

    const rows = this.planIdRowsTarget.querySelectorAll("[data-plan-id-row]")
    if (rows.length <= 1) {
      const input = row.querySelector("[data-plan-id-value]")
      if (input) input.value = ""
      return
    }

    row.remove()
  }

  buildPlanIdRow() {
    const max = this.planIdMaxValue()
    const tr = document.createElement("tr")
    tr.dataset.planIdRow = ""
    tr.innerHTML = `
      <td>
        <input class="form-control form-control-sm font-monospace" type="number"
          name="data_source[woocommerce][plan_ids][]" value="" placeholder="e.g. 8"
          autocomplete="off" min="1" max="${max}" step="1" data-plan-id-value="">
      </td>
      <td>
        <button class="btn btn-danger btn-sm" type="button"
          data-action="click->admin--data-source-page#removePlanId" aria-label="Remove plan ID">
          <i class="fas fa-times"></i>
        </button>
      </td>
    `
    return tr
  }

  planIdMaxValue() {
    const input = this.planIdRowsTarget?.querySelector("[data-plan-id-value]")
    return input?.max || "2147483647"
  }
}
